/** @deprecated */
interface BaseFilter {
  uri: string;
  label: string;
}

/** @deprecated */
interface FilterMetadata {
  is_new?: boolean;
}

/** @deprecated */
interface ListFilter extends BaseFilter {
  type: 'list';
  queryString: string;
  dataSource: string;
  multiSelection?: boolean;
  metadata?: FilterMetadata;
}

/** @deprecated */
interface BoolFilter extends BaseFilter {
  type: 'bool';
  queryString: string;
  sublabel?: string;
  metadata?: FilterMetadata;
}

/** @deprecated */
interface RangeFilter extends BaseFilter {
  type: 'range';
  min: ListFilter;
  max: ListFilter;
}

/** @deprecated */
interface LinkedFilter extends BaseFilter {
  type: 'linked';
  filters: ListFilter[];
}

/** @deprecated */
type SerializableFilter = ListFilter | BoolFilter;
/** @deprecated */
type CompositeFilter = ListFilter | BoolFilter | RangeFilter | LinkedFilter;

/** @deprecated */
class CategoryFilters {
  filters: CompositeFilter[];
  sparseFilters: SerializableFilter[];
  #searchableFilters: Map<string, SerializableFilter>;

  constructor(filters: CompositeFilter[], sparseFilters: SerializableFilter[]) {
    this.filters = filters;
    this.sparseFilters = sparseFilters;
    this.#searchableFilters = new Map(
      sparseFilters.map((filter) => {
        return [filter.queryString, filter];
      })
    );
  }

  filterForShortName(shortName: string): CompositeFilter | undefined {
    return this.#searchableFilters.get(shortName) as CompositeFilter;
  }
}

export { CategoryFilters };
export type {
  SerializableFilter,
  CompositeFilter,
  ListFilter,
  BoolFilter,
  RangeFilter,
  LinkedFilter,
};
